<template>
  <aside
    id="service"
    ref="service"
    class="container"
    :class="{'open' : modal}"
    tabindex="0"
  >
    <transition name="fade">
      <div
        v-if="modal"
        class="overlay"
        @click.stop="closeService"
      >
        <transition name="fade">
          <div
            v-if="modal"
            class="modal"
            @click.stop
          >
            <div class="top">
              <div
                class="category"
                :class="categoryColor"
              >
                <p class="name">
                  {{ categoryName }}
                </p>
                <p class="price">
                  <span>
                    {{ $t("total") }}:
                  </span>
                  <span class="total">
                    {{ displayTotal }}
                  </span>
                </p>
              </div>
              <div ref="body"
                   class="body">
                <div class="service">
                  <p class="name">
                    {{ service.name }}
                  </p>
                  <p v-if="getServiceDisplayPrice(service)"
                     class="price">
                    {{ getServiceDisplayPrice(service) }}
                  </p>
                  <div v-if="service.isHighlighted"
                       class="badge">
                    {{ $t("updated") }}
                  </div>
                </div>
                <!-- <span v-if="fullImage"> -->
                  <img v-if="fullImage && !isVideoOldMedia(thumbNail[0])"
                     :src="thumbNail[0]"
                     class="image" >
                <video v-if="fullImage && isVideoOldMedia(thumbNail[0])"
                     :src="thumbNail[0]"
                     class="image" controls autoplay playsinline>
                </video>

                <!-- </span> -->
                
                
              <div v-if = "!fullImage">
                <div class = "full-image-container" v-if="thumbNail !== null && thumbNail.length !== 0">
                    <span class = "left-arrow" @click.prevent="prevSlide" v-bind:class= "visibiltyLeftArrow" @click = "pause()"></span>
                    <div class = "image-container">
                      <ul class="slides" :style="{ left: -width * current + 'vw' }">
                        <li v-for="(x, i) in thumbNail" v-bind:key="i" >
                          <img v-if="!isVideo(x)" :src="x[1]">
                          <video v-if="isVideo(x)" :poster = "x[0]"
                           :src="x[1]" class="arrows" controls playsinline></video>
                        </li>
                      </ul>
                    </div>
                    <span  class = "right-arrow" @click.prevent="nextSlide" v-bind:class= "visibiltyRightArrow" @click = "pause()"></span>
                  </div>
               </div>
               <span v-if = "!fullImage">
                <div class = "slide-number" v-if="thumbNail !== null && thumbNail.length !== 0">
                        {{current+1}}/{{ thumbNail.length }}
                 </div>
               </span>
               
                <div class="details"
                     :class="{ 'no-image' : !service.imageUrl && service.isHighlighted }">
                  <p v-if="warranty"
                     class="warranty">
                    {{ warranty }}
                  </p>
                  <p v-if="comments.customer.header"
                     class="title">
                    {{ comments.customer.header }}:
                  </p>
                  <p v-if="comments.customer.text"
                     class="comment">
                    {{ comments.customer.text }}
                  </p>
                  <div v-if="comments.divider"
                       class="divider" />
                  <p v-if="comments.advisor.header"
                     class="title">
                    {{ comments.advisor.header }}:
                  </p>
                  <p v-if="comments.advisor.text"
                     class="comment">
                    {{ comments.advisor.text }}
                  </p>
                </div>
              </div>
            </div>
            <div class="footer" v-if="service.hideFooter ? !service.hideFooter : true">
              <div
                v-if="getServiceDisplayPrice(service) !== false"
                class = "approveService"
              >

         <input  
           :class="(service.isApproved || this.$store.state.isReadOnly) ? 'already-approved'  : 'approve'"
          v-model="service.isApproveSelected" 
          :id="`approve${service.id}`" 
          ref="input" 
          type="checkbox"
          value = "approve"
          name="approve" 
          @change="approve($event, service)" 
          @click.stop
          :disabled="this.$store.state.isReadOnly || service.isApproved"
          >
          <label 
          tabindex="0" 
          :for="`approve${service.id}`" 
          class="checkbox-approve" 
          @click.stop
          @keydown.enter="$refs.input.click()">
            {{ $t("approve") }}
            <div class="box">
              <img src="@/assets/images/check.svg" alt="check2" class="check">
            </div>
          </label>
          <input 
          v-model="service.isDeferSelected"  
          :id="`defer${service.id}`"
          ref="input" 
          type="checkbox"
          value = "defer"
          class="defer"
          name="defer" 
          :disabled="this.$store.state.isReadOnly || service.isApproved"
          @click.stop
          @change="reject($event, service)" 
         >
          <label 
          tabindex="0" 
          :for="`defer${service.id}`" 
          class="checkbox-defer"
          @click.stop
          @keydown.enter="$refs.input.click()">
            {{ $t("decline") }}
            <div class="box">
              <img src="@/assets/images/check.svg" alt="check1" class="check">
            </div>
          </label>
              </div>
              <nav class="navigation">
                <button
                  class="back"
                  @click="back()"
                >
                  {{ $t("back") }}
                </button>
                <button
                  class="next"
                  @click="next()"
                >
                  {{ $t("next") }}
                </button>
              </nav>
            </div>
          </div>
        </transition>
      </div>
    </transition>
  </aside>
</template>

<script>
import Vue from 'vue'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import { getServiceDisplayPrice, getTotal, focus, formatCurrency } from '@/mixins.js'

export default Vue.extend({
  name: 'ServicePopup',
  data: () => ({
    current: 0,
    width: 60,
  }),
  mixins: [getServiceDisplayPrice, getTotal, focus, formatCurrency],
  computed: {
    ...mapState([
      'modal',
      'service',
      'customerCommentsLabel',
      'inspectionLevelMediaUrls'      
    ]),
    ...mapGetters([
      'serviceById',
      'categoriesShown',
      'categoryServicesShownOnRoute',
      'count',
      'isPass',
      'deferredServices',
      'additionalServices',
      'total'
    ]),
    services () {
      let services = []
      for (const category of this.categoriesShown) {
        if (!this.isPass(category.id)) {
          services = services.concat(this.categoryServicesShownOnRoute(category.id))
        }
      }
      return services.filter(service => service.category !== '3')
    },
    categoryColor () {
      if (this.service.category === '1') return 'red'
      if (this.service.category === '2') return 'yellow'
      if (this.service.category === '3') return 'green'
      if (this.service.category === '6') return 'grey'
      if (this.service.category === '7') return 'grey'
      if (this.service.category === '8') return 'grey'
      if (this.service.category === '9') return 'grey'
      return ''
    },
    categoryName () {
      return this.$store.getters.categoryName(this.service.category)
    },
    displayTotal () {
      let total = ''
      if (this.$route.name === 'additional-services') {
        total = this.formatCurrency(this.getTotal(this.additionalServices))
      } else if (this.$route.name === 'wait-services') {
        total = this.formatCurrency(this.getTotal(this.deferredServices) + this.getTotal(this.additionalServices))
      } else if (this.$route.name === 'services') {
        total = this.formatCurrency(this.total.inspection)
      }
      return total
    },
    warranty () {
      let text = ''
      if (this.service.price === 0 && this.service.laborMatrixPayment) {
        if (this.service.laborMatrixPayment !== 'NA' && this.service.laborMatrixPayment !== 'None') {
          text = this.$t(`${this.service.laborMatrixPayment}`)
        }
      }
      return text
    },
    comments () {
      let customer = {
        header: '',
        text: ''
      }
      let advisor = {
        header: '',
        text: ''
      }

      if (this.service.category > '5') {
        if (this.service.parentServiceId) {
          customer.text = this.serviceById(this.service.parentServiceId).comment
        } else {
          customer.text = this.service.comment
        }
        if (customer.text) {
          customer.header = this.customerCommentsLabel
        }

        if (this.service.serviceAdvisorComments) {
          advisor.text = this.service.serviceAdvisorComments
        }
        if (advisor.text) {
          advisor.header = this.$t('advisor_comments')
        }
      } else {
        advisor.text = this.service.serviceAdvisorComments
      }

      let divider = customer.text && advisor.text

      return {
        customer,
        advisor,
        divider
      }
    },
    approveButtonColor () {
      let className = 'green'
      if (this.additionalServices.length) {
        if (!this.service.isSelected) {
          className = 'white'
        }
      }
      return className
    },
    displayApproveButtons () {
      let display = true
      if (this.service.category >= '8') {
        display = false
      }
      if (this.service.category === '1' || this.service.category === '2') {
        if (!this.service.parentServiceId && !this.service.subServices) {
          display = false
        }
      }
      return display
    },
    fullImage () {
        console.log("asdaad" + this.service.oldApp);
        return this.service.oldApp;
    },
    visibiltyLeftArrow() {
      return this.current+1 > 1 ? 'visibilty-yes' : 'visibility-no';
    },
    visibiltyRightArrow() {
      return this.current+1 < this.thumbNail.length ? 'visibilty-yes' : 'visibility-no';
    },
    thumbNail () {
      let fullUrls =[];
      let selectedImageUrl = this.service.selectedImageURL;
      if (this.service && this.service.imageUrls) {
      this.service.imageUrls.forEach((element, i) => {
          let fullUrl = element.split(';');
          fullUrls.push(fullUrl.length > 1 ? fullUrl : [fullUrl[0], fullUrl[0]]);
          if (fullUrl[0] === selectedImageUrl) {
            this.current = i;
          }
        })
      return fullUrls;
      } else if (this.service && this.service.itemLevelMediaUrls) {
          this.service.itemLevelMediaUrls.forEach((element, i) => {
          let fullUrl = element.split(';');
          fullUrls.push(fullUrl.length > 1 ? fullUrl : [fullUrl[0], fullUrl[0]]);
          if (fullUrl[0] === selectedImageUrl) {
          this.current = i;
        }
        });
        return fullUrls 
        } else {
          
          let imageURL = this.service.imageUrl;
          if (imageURL) {
            let imageArray = this.service.imageUrl.split(';');
            if(imageArray.length  > 1 ) {
               return [this.service.imageUrl.split(';')[1]]
            } else {
               return [this.service.imageUrl.split(';')[0]]
            }
          } else {
            return [''];
          }
      }
    },
  },
  watch: {
    modal (open) {
      if (open) {
        this.focus('#service')
      } else {
        this.focus(`#card${this.service.id}`)
        this.current = 0;
      }
    },
    service () {
      if (this.$refs.body) {
        this.$refs.body.scrollTo({
          left: 0,
          top: 0,
          behavior: 'smooth'
        })
      }
    }
  },
  destroyed () {
    this.current = 0;
    this.closeService()
  },
  methods: {
    ...mapMutations([
      'closeService',
      'openReason',
      'selectService',
      'unselectService',
      'logEvent'
    ]),
    ...mapActions([
      'viewService',
      'getTax'
    ]),
    isVideo(slide) {      
      if (slide !== null) {
        let splitedArray = slide[1].split('.')
        let lastValueOfArray = splitedArray[splitedArray.length - 1].split('?')[0]
        return (lastValueOfArray === 'mp4' || lastValueOfArray === 'flv' || lastValueOfArray === 'm4a' || lastValueOfArray === '3gp' || lastValueOfArray === 'mkv' || lastValueOfArray === 'mov' || lastValueOfArray === 'mkv')
      }
      return false
    },
    isVideoOldMedia(slide) {      
      if (slide !== null) {
        let splitedArray = slide.split('.')
        let lastValueOfArray = splitedArray[splitedArray.length - 1].split('?')[0]
        return (lastValueOfArray === 'mp4' || lastValueOfArray === 'flv' || lastValueOfArray === 'm4a' || lastValueOfArray === '3gp' || lastValueOfArray === 'mkv' || lastValueOfArray === 'mov' || lastValueOfArray === 'mkv')
      }
      return false
    },
    pause() {
       let allVideos = document.getElementsByClassName("arrows");
       for (let i = 0; i< allVideos.length; i++) {
        allVideos[i].pause();
       }
       
        },
    approve(event, service) {
      event.stopPropagation()
        if(service.isApproved)
        {         
          return;
        }        
      this.selectService()
      this.logEvent(`Selected service ${this.service.id}`)
     
      if(event.target.checked) {
        service.isDeferSelected = false
        service.isApproveSelected = true
        service.isSelected = true
        } else {
        service.isApproveSelected = false
        service.isSelected = false
        }
        if (this.$route.name === 'additional-services' || this.$route.name === 'wait-services') {
        this.next()
      } else {
        this.closeService()
      }
    },
    reject(event, service) {
      event.stopPropagation()
      if(service.isApproved)
      {
        return;
      }      
      this.unselectService()
          if (event.target.checked) {
            service.isDeferSelected = true
            service.isApproveSelected = false;
            if(this.$store.state.isDisableDeclineReasons != true) {
              this.openReason()
            } else {
              service.declinedReasonId = 0
            }
           service.isSelected = false
          } else {
            service.isDeferSelected = false
            service.isSelected = false;
          }
    },
    next () {
      const index = this.services.findIndex(service => service.id === this.service.id)
      if (index === undefined) return
      if (index < this.services.length - 1) {
        this.viewService(this.services[index + 1])
      } else {
        this.closeService()
        this.logEvent(`Finished viewing service ${this.service.id}`)
      }
    },
    back () {
      const index = this.services.findIndex(service => service.id === this.service.id)
      if (index > 0) {
        this.viewService(this.services[index - 1])
      } else {
        this.closeService()
      }
    },
    nextSlide: function() {
      this.current++;
      if(this.service.imageUrls) {
        if (this.current >= this.inspectionLevelMediaUrls.length) {
          this.current = 0;
        }
        
      } else {
        if (this.current >= this.service.itemLevelMediaUrls.length) {
          this.current = 0;
        }
      }
    
    },
    prevSlide: function() {
      this.current--;
      if(this.service.imageUrls) {
        if (this.current < 0 ) {
          this.current = this.inspectionLevelMediaUrls.length - 1;
        }
        
      } else {
        if (this.current < 0) {
          this.current = this.service.itemLevelMediaUrls.length - 1;
        }
      }
    }
  }
})
</script>

<style scoped lang="scss">
.container {
  position: absolute;
  bottom: 0;
  z-index: 1;
  height: 100%;
  width: 100%;
  overflow-y: hidden;
  pointer-events: none;
}

.slide-number {
  padding: 24px 0px;
  color: #1A1C21;
  font-size: 22px;
  font-weight: 700;
  line-height: 32px;
  word-wrap: break-word;
  text-align: center;
}

*:focus {
    outline: none;
}

.full-image-container {
  display: flex;
  align-items: center;
  // margin: auto;
  .image-container {
  margin: 0 auto;
  padding: 0;
  width: 60vw;
  height: 50vh;
  position: relative;
  overflow: hidden;
  ul.slides {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    display: table;
    position: absolute;
    top: 0;
    transition: left 800ms;

    li {
      list-style-type: none;
      display: table-cell;
      // img {
      //   width: 100%;
      //   // max-width: 100%;
      //   max-height: auto;
      //   object-fit: contain;
      // }
      // video {
      //   width: 100%;
      //   // max-width: 100%;
      //   max-height: auto;
      //   object-fit: contain;
      // }
      
    }
  }
 }
}

.image-container {
  img {
        width: 60vw;
        // max-width: 100%;
        height: 50vh;
        object-fit: contain;
      }
      video {
        width: 60vw;
        
        object-fit: contain;
        height:50vh ;
      }
}

.visibilty-yes {
    visibility: visible;
  } 
   .visibility-no {
    visibility: hidden;
   }

.right-arrow {
    cursor: pointer;
    margin-right: 40px;
    content: url("data:image/svg+xml,%3Csvg width='14' height='26' viewBox='0 0 14 26' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M0.964289 25.085C0.365042 24.513 0.34296 23.5635 0.914969 22.9643L10.0968 13.3452C10.2812 13.152 10.2812 12.848 10.0968 12.6548L0.914968 3.03571C0.342959 2.43646 0.365041 1.48697 0.964288 0.914965C1.56354 0.342956 2.51303 0.365038 3.08503 0.964285L12.2669 10.5833C13.5579 11.9358 13.5579 14.0642 12.2669 15.4167L3.08504 25.0357C2.51303 25.635 1.56354 25.657 0.964289 25.085Z' fill='%23343741'/%3E%3C/svg%3E%0A");
  }

  .left-arrow {
    cursor: pointer;
    margin-left: 40px;
    content: url("data:image/svg+xml,%3Csvg width='14' height='26' viewBox='0 0 14 26' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M13.0357 25.085C13.635 24.513 13.657 23.5635 13.085 22.9643L3.90321 13.3452C3.71878 13.152 3.71878 12.848 3.90321 12.6548L13.085 3.03571C13.657 2.43646 13.635 1.48697 13.0357 0.914965C12.4365 0.342956 11.487 0.365038 10.915 0.964285L1.73314 10.5833C0.442136 11.9358 0.442135 14.0642 1.73314 15.4167L10.915 25.0357C11.487 25.635 12.4365 25.657 13.0357 25.085Z' fill='%23343741'/%3E%3C/svg%3E%0A");
  }
.overlay {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  pointer-events: initial;
  background-color: var(--grey-transparent);
  .modal {
    height: 100%;
    width: 100%;
    // max-width: 768px;
    margin: 0;
    display: flex;
    flex-direction: column;
    @media (min-width: 992px) {
      max-height: calc(100% - 4rem);
      margin: 0 2rem;
    }
    background-color: var(--white);
    pointer-events: initial;
    .top {
      height: 100%;
      min-height: 0px;
      display: flex;
      flex-direction: column;
      flex: 1;
      .category {
        display: flex;
        justify-content: space-between;
        padding: 1rem;
        color: var(--white);
        &.red {
          background-color: var(--red);
        }
        &.yellow {
          background-color: var(--yellow);
        }
        &.green {
          background-color: var(--green-pastel);
        }
        &.grey {
          background-color: var(--grey-dark-background);
        }
        .name {
          flex: 100 100 50%;
          display: flex;
          margin: 0;
          padding: 1rem;
          align-items: center;
          border-right: 2px solid var(--white);
        }
        .price {
          flex: 100 100 30%;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          margin: 0;
          padding: 1rem;
          white-space: nowrap;
          .total {
            padding-left: 0.5rem;
          }
        }
      }
      .body {
        height: 100%;
        display: flex;
        flex-direction: column;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
        .service {
          position: relative;
          flex-shrink: 0;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 1rem;
          .name {
            margin: 0;
            padding: 1rem;
          }
          .price {
            margin: 0;
            padding: 1rem;
            border-radius: 500px;
            color: var(--blue);
            font-weight: 700;
            letter-spacing: 0.0625rem;
            font-family: 'Futura Heavy';
            background-color: var(--grey-light-background);
            text-align: center;
            white-space: nowrap;
          }
        }
        .badge {
          position: absolute;
          bottom: -4rem;
          left: 2rem;
          padding: 0.5rem 1rem;
          background-color: var(--green-pastel);
          border-radius: 500px;
          font-family: 'Futura Heavy';
          color: var(--white);
          text-transform: uppercase;
        }
        .image {
          width: 100%;
          max-height: 60%;
          padding: 1rem 0;
          object-fit: contain;
          background-color: var(--grey-light-background);
        }
        .details {
          padding: 2rem;
          .warranty {
            color: var(--blue);
          }
          .comment, .warranty {
            margin: 1rem 0 2rem 0;
            flex-shrink: 0;
          }
          .title {
            margin-bottom: 0;
            font-family: 'Futura Heavy';
            font-weight: 700;
          }
          .divider {
            width: 100%;
            height: 1px;
            background-color: var(--grey-light-background);
          }
          &.no-image {
            margin-top: 3em;
          }
        }
      }
    }
    .footer {
      .navigation {
        display: flex;
        justify-content: space-between;
        padding: 0 2rem;
        border-top: 1px solid var(--grey-light-background);
        @media (min-height: 768px) {
          margin-top: 1rem;
          padding: 1rem 2rem;
          border-bottom: 1px solid var(--grey-light-background);
        }
        .back, .next {
          padding: 1rem;
          border: none;
          background-color: var(--white);
          font-size: 1.5rem;
          text-transform: uppercase;
        }
        .back {
          color: var(--grey-dark-background);
        }
        .next {
          font-family: 'Futura Heavy';
          font-weight: 700;
        }
      }

      .approveService{
          display: flex;
          min-width: 200px;
          justify-content: space-around;
        }
        input {
          display: none;
        }
        .checkbox-defer {
          float: right;
          display: flex;
          align-items: center;
          transition: all .2s ease-in;
          text-transform: uppercase;
          color: var(--grey-text);

          .box {
            display: inline-flex;
            justify-content: center;
            align-items: center;
            width: 2.5rem;
            height: 2.5rem;
            margin-left: 1rem;
            border-radius: 3px;
            background-color: var(--grey-medium-background);

            .check {
              max-height: 100%;
              max-width: 100%;
              padding: 0.3rem;
              opacity: 0;
            }
          }
        }
        .checkbox-approve {
          float: right;
          display: flex;
          align-items: center;
          transition: all .2s ease-in;
          text-transform: uppercase;
          color: var(--grey-text);
          .box {
            display: inline-flex;
            justify-content: center;
            align-items: center;
            width: 2.5rem;
            height: 2.5rem;
            margin-left: 1rem;
            border-radius: 3px;
            background-color: var(--grey-medium-background);
            .check {
              max-height: 100%;
              max-width: 100%;
              padding: 0.3rem;
              opacity: 0;
            }
          }
        }
        input.already-approved:checked~.checkbox-approve {
          color: var(--green);
          .box {
            background-color: none;
            .check {
              opacity: 1;
            }
          }
        }     
        input.approve:checked~.checkbox-approve {
          color: var(--green);
          .box {
            background-color: var(--green);

            .check {
              opacity: 1;
            }
          }
        }
        input.defer:checked~.checkbox-defer {
          color: var(--red);
          .box {
            background-color: var(--red);

            .check {
              opacity: 1;
            }
          }
        }
        input.defer:checked~.checkbox-defer {
          color: var(--red);
          .box {
            background-color: var(--red);
            .check {
              opacity: 1;
            }
          }
        }
      }
      @media (max-width: 420px) {
          .bottom {
            display: flex;
            flex-flow: column;
            align-items: flex-start!important;
            margin-top: 0px;
            .approveService {
             flex-flow: column;
             margin-top: 4px;

             .checkbox-defer {
              margin-left: 20px;
              margin-top: 4px;
             }
             .price{
              margin-bottom: 2px;
             }
            }
          }
      .buttons {
        margin: 0 2rem;
        .button {
          margin: 0;
          @media (min-height: 768px) {
            margin: 1rem 0;
          }
          &.white {
            font-weight: 400;
            font-family: 'Futura Book';
            color: var(--grey-dark-background);
            background-color: var(--white);
            box-shadow: none;
          }
          &.skip {
            margin: .5rem 0 0 0;
          }
        }
      }
    }
  }
}
</style>
